import { useMemo, useState, useEffect } from "react";
import * as React from "react";
import { View, StyleSheet, ViewStyle } from "react-native";

import { useHubRefurbishHistoryQuery } from "@/api/hub";

import { ListItemLabelValueCompact } from "@/common/ListItemLabelValueCompact";
import { NoContent } from "@/pages/hub-page/NoContent";

import NoRecords from "@/common/NoRecords";

import { TABS } from "../HubInfo";

interface HubRefurbishHistoryComponentProps {
  serial: string;
  fetchData: string;
}
export const HubRefurbishHistory: React.FC<
  React.PropsWithChildren<HubRefurbishHistoryComponentProps>
> = ({ serial, fetchData }) => {
  const [shouldRefetch, setShouldRefetch] = useState(true);

  const {
    data: hubRefurbishHistoryLogs,
    isError,
    refetch,
  } = useHubRefurbishHistoryQuery(
    { serial },
    {
      refetchInterval: shouldRefetch ? 5000 : false,
      onError: () => setShouldRefetch(false),
    }
  );

  useEffect(() => {
    const refetchAndSetInterval = () => {
      refetch();
      setShouldRefetch(true);
    };
    if (fetchData === TABS.hubRefurbishHistory) {
      refetchAndSetInterval();
    }
  }, [refetch, fetchData]);

  const logs = useMemo(
    () =>
      hubRefurbishHistoryLogs?.records?.length
        ? hubRefurbishHistoryLogs.records.reverse() // we want most recent inserted_at time to be first
        : [],
    [hubRefurbishHistoryLogs]
  );

  return (
    <View style={styles.container}>
      {isError ? (
        <NoContent isError={true} />
      ) : (logs || []).length === 0 ? (
        <NoRecords title="No Hub Refurbish History Found." />
      ) : (
        logs.map(({ serial, inserted_at }, key) => (
          <ListItemLabelValueCompact
            key={key}
            value={serial}
            timestamp={inserted_at}
            style={styles.logItem}
            timestampOpts={{ opts: { timeZone: "UTC" } }}
          />
        ))
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    maxHeight: 500,
    overflow: "auto",
    padding: 16,
  } as Omit<ViewStyle, "overflow">,
  logItem: {
    marginBottom: 8,
  },
});
